import { render } from "./test.vue?vue&type=template&id=072ba808&scoped=true&ts=true"
import script from "./test.vue?vue&type=script&lang=ts"
export * from "./test.vue?vue&type=script&lang=ts"

import "./test.vue?vue&type=style&index=0&id=072ba808&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072ba808"]])

export default __exports__